export default "__VITE_ASSET__D4BrbO7w__"